import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksFooter', {
    taxLineTextExclusive: 'Tax {percent}% on {taxableAmount}:',
    taxLineTextInclusive: 'Includes Tax {percent}% on {taxableAmount}:',
    totalText: 'Total ({currency}):',
    subtotalText: 'Subtotal ({currency}):',
    discountText: 'Discount:',
    discountTextPercent: 'Discount ({discount}%):',
    shippingText: 'Shipping:',
    taxOnShippingText: 'Tax on shipping:',
    differentSubtotalWarningLabel1: 'Bill subtotal',
    differentSubtotalWarningLabel2: 'File subtotal',
    differentTaxTotalWarningLabel1: 'Bill tax total',
    differentTaxTotalWarningLabel2: 'File tax total',
    differentTotalWarningLabel1: 'Bill total',
    differentTotalWarningLabel2: 'File total',
    differentSubtotalWarningDescription: 'Bill subtotal differs from File subtotal',
    differentTaxTotalWarningDescription: 'Bill tax total differs from File tax total',
    differentTotalWarningDescription: 'Bill total differs from File total',
});
